'use client';

import {
    DOMNode,
    domToReact,
} from 'html-react-parser';
import {
    useCallback,
    MouseEvent,
    useMemo,
    PropsWithChildren,
} from 'react';
import Link from 'next/link';
import styles from './WpPostNavigation.module.scss';
import { handleNavigationClick } from '@app/utils/handleNavigationClick';

export interface IProps extends PropsWithChildren{
    /**
     * Аттрибут id элемента
     */
    id: number;
    /**
     * HTML тэг элемента
     */
    name: string;
}

/**
 * Ссылка в навигационном меню
 */
export default function WpPostNavigationLink({
    id,
    name,
    children,
}: IProps) {
    /**
     * Обработчик клика
     *
     * @param e - Событие
     */
    const didClick = useCallback((e: MouseEvent) => {
        handleNavigationClick(e, id.toString());
    }, [id]);

    const parsedChildren = useMemo(() =>
        domToReact(children as DOMNode[])
    , [children]);

    return (
        <Link
            href=""
            className={styles[`post__navigation_${name}`]}
            onClick={didClick}
        >
            {parsedChildren}
        </Link>
    );
}